import { getGuessStatuses} from '../../lib/statuses'
import { Cell } from './Cell'
import { unicodeSplit, solution } from '../../lib/words'

type Props = {
  guess: string
  isRevealing?: boolean
  isHardMode: boolean
}

export const CompletedRow = ({ guess, isRevealing, isHardMode }: Props) => {
  const statuses = getGuessStatuses(guess)
  const splitGuess = unicodeSplit(guess)
  const splitfirstGuess = splitGuess.slice(0,4)
  const splitsecondGuess = splitGuess.slice(4)
  
  const yearfrom = guess.substring(0,4)
  const yearto = guess.substring(4, 8)
  const solutionfrom = solution.substring(0,4)
  const solutionto = solution.substring(4, 8)
  
	var pointer1
	var pointer2
	
	if (parseInt(yearfrom.trim()) < parseInt(solutionfrom.trim())) pointer1 = "up.png"
	if (parseInt(yearfrom.trim()) > parseInt(solutionfrom.trim())) pointer1 = "down.png"
	if (parseInt(yearfrom.trim()) === parseInt(solutionfrom.trim())) pointer1 = "right.png"
	

	if (parseInt(yearto.trim()) < parseInt(solutionto.trim())) pointer2 = "up.png"
	if (parseInt(yearto.trim()) > parseInt(solutionto.trim())) pointer2 = "down.png"
	if (parseInt(yearto.trim()) === parseInt(solutionto.trim())) pointer2 = "left.png"
	
	const alt1 = String(pointer1).replace(".png", "")
	const alt2 = String(pointer2).replace(".png", "")
	
	const pointerclasses = 'w-8 h-14 flex items-center justify-center mx-0.5 text-4xl font-bold rounded dark:text-white'
      //'cell-fill-animation': isFilled,
      //'cell-reveal': shouldReveal,
  
  return (
	<div className="flex justify-center mb-1">
		<div className={pointerclasses}>
    	<div className="letter-container">
			{isHardMode ? <br/>:<img max-width="80%" max-height="80%" object-fit="contain" src={pointer1} alt={alt1} />} 
		</div>
		</div>
      {splitfirstGuess.map((letter, i) => (
        <Cell
          key={i}
          value={letter}
          status={statuses[i]}
          position={i}
          isRevealing={isRevealing}
          isCompleted
        />
      ))}
	  
	  
	  <Cell key ="5" value="-" />
	  
	  {splitsecondGuess.map((letter, i) => (
        <Cell
          key={i+4}
          value={letter}
          status={statuses[i+4]}
          position={i+4}
          isRevealing={isRevealing}
          isCompleted
        />
      ))}
	  <div className={pointerclasses}>
    	<div className="letter-container">
			{isHardMode ? <br/>:<img max-width="80%" max-height="80%" object-fit="contain" src={pointer2} alt={alt2}/> }
		</div>
		</div>
    </div>
  )
}
